import { useBasketMethods } from '@/composables/useBasketMethods'

import { useAnalyticsStore } from '@/store/analytics/analytics'
import { useAppStore } from '@/store/app/app'
import { useCityStore } from '@/store/city/city'
import { useToggleStore } from '@/store/toggle/toggle'
import { useUserStore } from '@/store/user/user'

import { NotFoundError } from '@/api/results'

import { IncomingHttpHeaders } from 'http'

export default defineNuxtPlugin(async () => {
  const nuxtApp = useNuxtApp()
  const isServer = import.meta.server
  const cityPrefix = nuxtApp.$cityPrefix as string

  if (isServer) {
    const result = await handleServerSide(
      cityPrefix,
      nuxtApp.ssrContext?.event.node.req.headers,
      nuxtApp.$sentryCaptureException,
    )

    if (!result.success) {
      await navigateTo('https://farfor.ru/', {
        external: true,
      })
    }

    await fetchVarioqub()

    return
  }

  await handleClientSide(cityPrefix, nuxtApp.$sentryCaptureException)
})

async function handleServerSide(
  cityPrefix: string,
  headers: IncomingHttpHeaders | undefined,
  captureException: (err: unknown) => void,
) {
  const analyticsStore = useAnalyticsStore()
  const cityStore = useCityStore()
  const toggleStore = useToggleStore()
  const appStore = useAppStore()

  appStore.detectWebview(headers)

  try {
    const [cityResult] = await Promise.all([
      cityStore.getCityInfo(cityPrefix),
      analyticsStore.getAnalyticsCity(),
      toggleStore.getFeatureToggles(),
    ])

    if (cityResult instanceof NotFoundError) {
      return { success: false }
    }

    return { success: true }
  } catch (err) {
    captureException(err)

    showError({
      ...err,
      message: `Модель города не была получена: Город: ${cityPrefix}`,
    })

    return { success: false }
  }
}

async function handleClientSide(
  cityPrefix: string,
  captureException: (err: unknown) => void,
) {
  const { cityInfo, getCityInfo } = useCityStore()
  const { fetchBasket } = useBasketMethods()
  const { getInfo } = useUserStore()
  const { getFeatureToggles } = useToggleStore()
  const { getAnalyticsCity } = useAnalyticsStore()

  const cityPromise = !cityInfo.domain_prefix
    ? getCityInfo(cityPrefix)
    : Promise.resolve()

  try {
    await Promise.all([
      cityPromise,
      fetchBasket(),
      getInfo({
        serverSide: false,
        isUserPages: false,
        urlPage: '',
      }),
      getFeatureToggles(),
      getAnalyticsCity(),
    ])
  } catch (err) {
    captureException(err)
  }
}

async function fetchVarioqub() {
  const toggleStore = useToggleStore()

  if (!toggleStore.featureToggle.varioqub_enabled) return

  try {
    await toggleStore.getVarioqub()
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
  }
}
